import {
  RecordCustomerContactAttemptRequest,
  RecordCustomerContactAttemptRequestBody,
  RecordCustomerContactAttemptResponse,
} from '@eigtech/restoration-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { restorationBasePath } from './constants'

const recordCustomerContactAttempt = ({ jobId, ...payload }: RecordCustomerContactAttemptRequest) =>
  contextualPost<RecordCustomerContactAttemptResponse, RecordCustomerContactAttemptRequestBody>(
    `${restorationBasePath}/job/${jobId}/record-customer-contact-attempt`,
    payload,
    { responseType: 'none' }
  )

export type OnSuccessRecordCustomerContactAttempt = (
  response: RecordCustomerContactAttemptRequest
) => Promise<void>

export function useRecordCustomerContactAttempt(
  onSuccessHandler?: OnSuccessRecordCustomerContactAttempt
) {
  return useMutation({
    mutationFn: recordCustomerContactAttempt,
    async onSuccess(__, response) {
      if (onSuccessHandler) await onSuccessHandler(response)
    },
  })
}
